(function () {
  "use strict";

  var VERSION = "2026-05-26";
  var STORAGE_KEY = "minimog-discount-code";
  var SCRIPT_FLAG = "__vaelleafCartDiscountSync";
  var DISCOUNT_INPUT_SELECTOR = 'input[name="discount"]';
  var CART_FORM_SELECTORS = [
    "#cart-drawer-form",
    'form[action="/cart"]',
    'form[action$="/cart"]',
    'form[action*="/cart?"]'
  ];
  var CART_MUTATION_PATHS = [
    "/cart/add",
    "/cart/add.js",
    "/cart/change",
    "/cart/change.js",
    "/cart/update",
    "/cart/update.js",
    "/cart/clear",
    "/cart/clear.js"
  ];

  if (window[SCRIPT_FLAG]) return;
  window[SCRIPT_FLAG] = true;

  var syncTimer = 0;
  var inFlightSync = null;
  var resubmittingForms = new WeakSet();

  function getRootPath() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root) return "/";
    return root.charAt(root.length - 1) === "/" ? root : root + "/";
  }

  function getCartUrl() {
    return getRootPath() + "cart.js";
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* Storage can be unavailable in some embedded browsers. */
    }
  }

  function safeStorageRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      /* Storage can be unavailable in some embedded browsers. */
    }
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function normalizeCode(value) {
    if (value == null) return "";
    var code = String(value).trim();
    if (!code || code === "null" || code === "undefined") return "";
    return code;
  }

  function isLikelyDiscountCode(value) {
    var code = normalizeCode(value);
    if (!code) return false;
    if (code.length > 80) return false;
    if (/\s/.test(code)) return false;
    if (/^fx-/i.test(code)) return false;
    return /[A-Za-z0-9]/.test(code);
  }

  function getFirstCodeFromDiscountCodes(discountCodes) {
    if (!Array.isArray(discountCodes)) return "";

    for (var i = 0; i < discountCodes.length; i += 1) {
      var discount = discountCodes[i] || {};
      var code = normalizeCode(discount.code);
      if (code && discount.applicable !== false) return code;
    }

    for (var j = 0; j < discountCodes.length; j += 1) {
      var fallbackCode = normalizeCode((discountCodes[j] || {}).code);
      if (fallbackCode) return fallbackCode;
    }

    return "";
  }

  function getFirstCodeFromCartLevelApplications(applications) {
    if (!Array.isArray(applications)) return "";

    for (var i = 0; i < applications.length; i += 1) {
      var application = applications[i] || {};
      var title = application.title || application.code;
      if (isLikelyDiscountCode(title)) return normalizeCode(title);
    }

    return "";
  }

  function getFirstCodeFromLineItems(items) {
    if (!Array.isArray(items)) return "";

    for (var i = 0; i < items.length; i += 1) {
      var item = items[i] || {};
      var discounts = item.discounts || [];

      for (var d = 0; d < discounts.length; d += 1) {
        var discountTitle = discounts[d] && discounts[d].title;
        if (isLikelyDiscountCode(discountTitle)) return normalizeCode(discountTitle);
      }

      var allocations = item.line_level_discount_allocations || [];
      for (var a = 0; a < allocations.length; a += 1) {
        var allocation = allocations[a] || {};
        var application = allocation.discount_application || {};
        var allocationTitle = application.title || application.code;
        if (isLikelyDiscountCode(allocationTitle)) return normalizeCode(allocationTitle);
      }
    }

    return "";
  }

  function getDiscountCodeFromCart(cart) {
    if (!cart) return "";
    return (
      getFirstCodeFromDiscountCodes(cart.discount_codes) ||
      getFirstCodeFromCartLevelApplications(cart.cart_level_discount_applications) ||
      getFirstCodeFromLineItems(cart.items)
    );
  }

  function fetchCart() {
    return window.fetch(getCartUrl(), {
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Failed to fetch cart.js");
      return response.json();
    });
  }

  function isCartForm(form) {
    if (!form || form.nodeType !== 1 || form.tagName !== "FORM") return false;

    if (form.id === "cart-drawer-form") return true;

    var action = form.getAttribute("action") || "";
    if (!action) return false;

    try {
      var url = new URL(action, window.location.href);
      var pathname = url.pathname.replace(/\/+$/, "");
      return /\/cart$/.test(pathname);
    } catch (error) {
      return /\/cart(?:\?|$)/.test(action);
    }
  }

  function getCartForms() {
    var forms = [];
    var seen = new Set();

    CART_FORM_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (form) {
        if (isCartForm(form) && !seen.has(form)) {
          forms.push(form);
          seen.add(form);
        }
      });
    });

    return forms;
  }

  function getAssociatedDiscountInputs(form) {
    var inputs = [];
    var seen = new Set();

    function addInput(input) {
      if (input && !seen.has(input)) {
        inputs.push(input);
        seen.add(input);
      }
    }

    form.querySelectorAll(DISCOUNT_INPUT_SELECTOR).forEach(addInput);

    if (form.id) {
      var selector = DISCOUNT_INPUT_SELECTOR + '[form="' + escapeSelector(form.id) + '"]';
      document.querySelectorAll(selector).forEach(addInput);
    }

    return inputs;
  }

  function ensureDiscountInput(form) {
    var inputs = getAssociatedDiscountInputs(form);
    if (inputs[0]) return inputs[0];

    var input = document.createElement("input");
    input.type = "hidden";
    input.name = "discount";
    input.setAttribute("data-vaelleaf-cart-discount-sync", "created");
    form.appendChild(input);
    return input;
  }

  function setCodeOnInputs(code) {
    var normalizedCode = normalizeCode(code);
    if (!normalizedCode) return;

    getCartForms().forEach(function (form) {
      var input = ensureDiscountInput(form);
      input.value = normalizedCode;
      input.setAttribute("data-vaelleaf-cart-discount-sync", "cart");
    });

    document.querySelectorAll(DISCOUNT_INPUT_SELECTOR).forEach(function (input) {
      if (input.closest("form") && !isCartForm(input.closest("form"))) return;
      input.value = normalizedCode;
      input.setAttribute("data-vaelleaf-cart-discount-sync", "cart");
    });

    safeStorageSet(STORAGE_KEY, normalizedCode);
    updateDiscountIndicators(true);
  }

  function clearSyncedCode() {
    getCartForms().forEach(function (form) {
      getAssociatedDiscountInputs(form).forEach(function (input) {
        if (input.getAttribute("data-vaelleaf-cart-discount-sync") === "cart") {
          input.value = "";
          input.removeAttribute("data-vaelleaf-cart-discount-sync");
        }
      });
    });

    safeStorageRemove(STORAGE_KEY);
    updateDiscountIndicators(false);
  }

  function updateDiscountIndicators(hasCode) {
    document.querySelectorAll("[data-discount-noti]").forEach(function (indicator) {
      indicator.style.display = hasCode ? "" : "none";
    });
  }

  function syncFromCart(options) {
    var force = options && options.force;
    if (inFlightSync && !force) return inFlightSync;

    inFlightSync = fetchCart()
      .then(function (cart) {
        var code = getDiscountCodeFromCart(cart);

        if (code) {
          setCodeOnInputs(code);
          return code;
        }

        if (cart && cart.item_count === 0) {
          clearSyncedCode();
        }

        return "";
      })
      .catch(function (error) {
        if (window.console && typeof window.console.warn === "function") {
          window.console.warn("[cart-discount-sync] Unable to sync cart discount", error);
        }
        return "";
      })
      .finally(function () {
        inFlightSync = null;
      });

    return inFlightSync;
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncFromCart();
    }, typeof delay === "number" ? delay : 120);
  }

  function isCheckoutSubmit(event, form) {
    var submitter = event.submitter || document.activeElement;
    if (submitter && submitter.name === "checkout") return true;
    if (submitter && submitter.getAttribute && submitter.getAttribute("name") === "checkout") return true;
    return !!form.querySelector('[name="checkout"]');
  }

  function submitCartForm(form, submitter) {
    if (typeof form.requestSubmit === "function") {
      try {
        if (submitter && submitter.form === form) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
        return;
      } catch (error) {
        /* Fall through to native submit. */
      }
    }

    if (!form.querySelector('input[name="checkout"]')) {
      var checkoutInput = document.createElement("input");
      checkoutInput.type = "hidden";
      checkoutInput.name = "checkout";
      checkoutInput.value = "checkout";
      checkoutInput.setAttribute("data-vaelleaf-cart-discount-sync", "created");
      form.appendChild(checkoutInput);
    }

    HTMLFormElement.prototype.submit.call(form);
  }

  function handleCartSubmit(event) {
    var form = event.target;
    if (!isCartForm(form) || !isCheckoutSubmit(event, form)) return;

    if (resubmittingForms.has(form)) {
      resubmittingForms.delete(form);
      return;
    }

    var input = ensureDiscountInput(form);
    if (normalizeCode(input.value)) return;

    event.preventDefault();

    syncFromCart({ force: true }).then(function (code) {
      if (code) {
        ensureDiscountInput(form).value = code;
      }

      resubmittingForms.add(form);
      submitCartForm(form, event.submitter);
    });
  }

  function handleDiscountInput(event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(DISCOUNT_INPUT_SELECTOR)) return;

    if (!normalizeCode(input.value)) {
      safeStorageRemove(STORAGE_KEY);
      input.removeAttribute("data-vaelleaf-cart-discount-sync");
      updateDiscountIndicators(false);
    }
  }

  function getRequestUrl(input) {
    if (typeof input === "string") return input;
    if (input && typeof input.url === "string") return input.url;
    return "";
  }

  function isCartMutationRequest(input, init) {
    var method = (init && init.method) || (input && input.method) || "GET";
    if (String(method).toUpperCase() === "GET") return false;

    try {
      var url = new URL(getRequestUrl(input), window.location.href);
      var pathname = url.pathname.replace(/\/+$/, "");
      return CART_MUTATION_PATHS.some(function (path) {
        return pathname === path || pathname.endsWith(path);
      });
    } catch (error) {
      return false;
    }
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__vaelleafCartDiscountSyncPatched) return;

    var nativeFetch = window.fetch;
    var patchedFetch = function (input, init) {
      var shouldSync = isCartMutationRequest(input, init);
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (shouldSync && response && response.ok) scheduleSync(160);
        return response;
      });
    };

    patchedFetch.__vaelleafCartDiscountSyncPatched = true;
    window.fetch = patchedFetch;
  }

  function subscribeToMinimogCartEvents(attempt) {
    var theme = window.MinimogTheme;
    var eventName = theme && theme.pubSubEvents && theme.pubSubEvents.cartUpdate;

    if (theme && typeof theme.subscribe === "function" && eventName) {
      theme.subscribe(eventName, function () {
        scheduleSync(80);
      });
      return;
    }

    if (attempt < 10) {
      window.setTimeout(function () {
        subscribeToMinimogCartEvents(attempt + 1);
      }, 300);
    }
  }

  document.addEventListener("submit", handleCartSubmit, true);
  document.addEventListener("input", handleDiscountInput, true);
  document.addEventListener("change", handleDiscountInput, true);

  [
    "cart:updated",
    "cart:update",
    "cart:refresh",
    "cart:build",
    "product:added",
    "product-ajax:added",
    "ajaxProduct:added"
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      scheduleSync(80);
    });
    window.addEventListener(eventName, function () {
      scheduleSync(80);
    });
  });

  window.addEventListener("pageshow", function () {
    scheduleSync(0);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      patchFetch();
      subscribeToMinimogCartEvents(0);
      scheduleSync(0);
    });
  } else {
    patchFetch();
    subscribeToMinimogCartEvents(0);
    scheduleSync(0);
  }

  window.VaelleafCartDiscountSync = {
    version: VERSION,
    sync: function () {
      return syncFromCart({ force: true });
    }
  };
})();
